export enum StepType {
  Modal = 'modal',
  Tooltip = 'tooltip',
}
export type StepNavigation = 'free' | 'action-required'

export interface WizardStepContent {
  title: string
  description?: string
  imageSrc?: string
}

export interface WizardStep {
  type: StepType
  content: WizardStepContent
  navigation?: StepNavigation
  anchorIdSuffix?: string
}

export interface WizardConfig {
  id: string
  title: string
  steps: WizardStep[]
}

export interface TutorialEntry {
  config: WizardConfig
  featureEnabled?: boolean
}
